import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";

/** Shared site phase (selling vs. between events). */
export const useSitePhase = () => {
  const [phase, setPhase] = useState(null);
  useEffect(() => {
    let cancelled = false;
    api.get("/site-phase")
      .then((r) => { if (!cancelled) setPhase(r.data); })
      .catch(() => { if (!cancelled) setPhase({ mode: "selling", sales_open: true, between_events: false }); });
    return () => { cancelled = true; };
  }, []);
  return phase;
};
